'use strict';

/* global $ */

class Sliders {
  constructor() {
      this.init();
  }
  init() {
      console.log('[ Sliders ] init');

      // this.jsSliderBig();
      this.jsSliderBigTop();
      // this.jsSliderLittle();
      this.jsSliderLittleBot();
      this.jsSlick();
      this.jsMaterialSlider();
      this.jsHeaderSlider();
      this.jsExampleSliderTop();
      this.jsExampleSliderBottom();
      this.jsFlampSlider();
      this.jsTeamSlider();
      this.jsThreeSlider();
      this.jsVariantSlider();
	  this.jsModifSlider();
  	  this.jsAdvantagesSlider();
  }
  jsThreeSlider() {
    if ($('.js-vors-3d').find('ol').length != 0) {
      $('.js-vors-3d').ThreeSixty({
        totalFrames: 45, // Total no. of image you have for 360 slider
			  endFrame: 45, // end frame for the auto spin animation
			  currentFrame: 1, // This the start frame for auto spin
			  imgList: '.threesixty_images', // selector for image list
			  progress: '.spinner', // selector to show the loading progress
			  imagePath: $('.js-vors-3d').data('src'), // path of the image assets
			  filePrefix: '', // file prefix if any
			  ext: '.png', // extention for the assets
			  height: '100%',
			  width: $('.js-vors-3d').width(),
			  navigation: false
		  });
    }
  }
  jsSliderBig() {
    $('.js-slider-big').slick({
      slidesToShow:1,
      slidesToScroll:1,
      arrows:false,
      asNavFor: '.js-slider-little',
    })
  }
  jsSliderBigTop() {
    $('.js-slider-big--top').slick({
      slidesToShow:1,
      slidesToScroll:1,
      arrows:true,
      infinite: false,
      //asNavFor: '.js-slider-little--bottom',
      prevArrow:'<div class="item__slider--prev"></div>',
      nextArrow:'<div class="item__slider--next"></div>',
    })
  }
  jsSliderLittle() {
    $('.js-slider-little').slick({
      slidesToShow:5,
      slidesToScroll:1,
      centerMode: true,
      arrows:true,
      focusOnSelect: true,
      centerPadding:5,
      asNavFor: '.js-slider-big',
      prevArrow:'<div class="item__slider--prev"></div>',
      nextArrow:'<div class="item__slider--next"></div>'
    })
  }
  jsSliderLittleBot() {
    $('.js-slider-little--bottom').slick({
      slidesToShow: 5,
      slidesToScroll:1,
      centerMode: false,
      infinite: false,
      arrows:false,
      focusOnSelect: true,
      centerPadding:5,
      asNavFor: '.js-slider-big--top',
      responsive: [
        {
          breakpoint: 786,
          settings: {
            slidesToShow: 4,
          }
        },
      ]
    })
  }
  jsSlick() {
    $('.js-slick').slick({
      arrows:true,
      prevArrow:'<div class="js-slick-prev"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.45705 4.82996L1.59347 5.68522L2.80889 5.68522L19.5 5.68522L19.5 6.31478L2.80889 6.31478L1.59347 6.31478L2.45705 7.17004L6.28826 10.9643L6.6401 10.6091L6.28826 10.9643C6.412 11.0869 6.412 11.2836 6.28826 11.4061C6.16184 11.5313 5.95488 11.5313 5.82846 11.4061L0.592798 6.22088C0.469064 6.09833 0.469064 5.90167 0.5928 5.77913L5.82846 0.593906C5.95488 0.4687 6.16184 0.4687 6.28826 0.593906C6.412 0.71645 6.412 0.913111 6.28826 1.03566L2.45705 4.82996Z" stroke="#FF7A00"/></svg></div>',
      nextArrow:'<div class="js-slick-next"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5429 7.17004L18.4065 6.31478H17.1911H0.5V5.68522H17.1911H18.4065L17.5429 4.82996L13.7117 1.03565L13.3599 1.39091L13.7117 1.03565C13.588 0.913109 13.588 0.716449 13.7117 0.593904C13.8382 0.468699 14.0451 0.468699 14.1715 0.593904L19.4072 5.77912C19.5309 5.90167 19.5309 6.09833 19.4072 6.22088L14.1715 11.4061C14.0451 11.5313 13.8382 11.5313 13.7117 11.4061C13.588 11.2836 13.588 11.0869 13.7117 10.9643L17.5429 7.17004Z" stroke="#FF7A00"/></svg></div>'
    });
	$('.js-slick').find('.js-slick-prev, .js-slick-next').on('click', function(event){ event.stopImmediatePropagation() });
  }
  jsMaterialSlider() {
    $('.js-material-slider').slick({
      slidesToShow:1,
      slidesToScroll:1,
      arrows:true,
      dots:true,
      prevArrow:'<div class="js-material-prev"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M2.45705 4.82996L1.59347 5.68522L2.80889 5.68522L19.5 5.68522L19.5 6.31478L2.80889 6.31478L1.59347 6.31478L2.45705 7.17004L6.28826 10.9643L6.6401 10.6091L6.28826 10.9643C6.412 11.0869 6.412 11.2836 6.28826 11.4061C6.16184 11.5313 5.95488 11.5313 5.82846 11.4061L0.592798 6.22088C0.469064 6.09833 0.469064 5.90167 0.5928 5.77913L5.82846 0.593906C5.95488 0.4687 6.16184 0.4687 6.28826 0.593906C6.412 0.71645 6.412 0.913111 6.28826 1.03566L2.45705 4.82996Z" stroke="#FFF"/></svg></div>',
      nextArrow:'<div class="js-material-next"><svg width="20" height="12" viewBox="0 0 20 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17.5429 7.17004L18.4065 6.31478H17.1911H0.5V5.68522H17.1911H18.4065L17.5429 4.82996L13.7117 1.03565L13.3599 1.39091L13.7117 1.03565C13.588 0.913109 13.588 0.716449 13.7117 0.593904C13.8382 0.468699 14.0451 0.468699 14.1715 0.593904L19.4072 5.77912C19.5309 5.90167 19.5309 6.09833 19.4072 6.22088L14.1715 11.4061C14.0451 11.5313 13.8382 11.5313 13.7117 11.4061C13.588 11.2836 13.588 11.0869 13.7117 10.9643L17.5429 7.17004Z" stroke="#FFF"/></svg></div>'
    });
  }
  jsVariantSlider() {
    $('.js-variant-slider').each(function(){
      $(this).slick({
        slidesToShow:1,
        slidesToScroll:1,
        arrows:true,
        dots:true,
        appendDots:$(this).siblings('.js-variant-slider__dots'),
        prevArrow:$(this).siblings('.js-variant-slider__arrows').find('.js-variant-slider__prev'),
        nextArrow:$(this).siblings('.js-variant-slider__arrows').find('.js-variant-slider__next')
      });
    });
  }
  jsHeaderSlider() {
    // Скрипт для слайдера
    $('.js-header-slider').slick({
      autoplay:true,
      autoplaySpeed:5000,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      slidesToShow: 1,
      swipe: false,
      cssEase: 'cubic-bezier(0.600, -0.280, 0.001, 0.001)',
      speed: 1500,
      fade: true,
      prevArrow: '<div class="header-slider-arrow--left"></div>',
      nextArrow: '<div class="header-slider-arrow--right"></div>',
      customPaging: function(slick, index) {
        var text = slick.$slides.eq(index).data('name');
        return '<div>'+text+'</div>';
      }
    });
    $('.js-header-slider').on('beforeChange',function(){
      $('.js-header').addClass('anim-right');
      setTimeout(function() {
        $('.js-header').css('background-image', 'url('+$('.slick-active').data('href')+')');
        $('.js-header').css('background-color',' rgba(0, 0, 0, '+$('.slick-active').data('blackout')+')');
      }, 750);
      setTimeout(function() {
        // удаление класса спустя время самой анимации
        $('.js-header').removeClass('anim-right');
    }, 1500);
    })
  }
  jsExampleSliderTop() {
    $('.js-examples-slider-top').each(function(){
      $(this).slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      speed: 500,
      asNavFor: $(this).siblings('.js-examples-slider-bottom'),
      lazyLoad: 'progressive',
    });
    })
  }
  jsExampleSliderBottom() {
    var sliderCount = 0;
    $('.js-examples-slider-bottom').each(function(){
      sliderCount += 1;
      $(this).slick({
      infinite: true,
      slidesToShow: 5,
      slidesToScroll: 1,
      asNavFor: $(this).siblings('.js-examples-slider-top'),
      dots: false,
      arrows: true,
      fade: false,
      speed: 500,
      cssEase: 'ease-in-out',
      prevArrow: '<div class="examples-slider-arrow--left"></div>',
      nextArrow: '<div class="examples-slider-arrow--right"></div>',
      centerMode: true,
      centerPadding: 0,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1201,
          settings: {
            slidesToShow: 5,
          }
        },
        {
          breakpoint: 1025,
          settings: {
            slidesToShow: 5,
          }
        },
      ]
    });
    })
  }
  jsAdvantagesSlider() {
	$(window).on('resize', function(e) {
		var initLib = $('.js-advantages-slider').data('init-slider');
		if (window.innerWidth < 576) {
		    $('.js-advantages-slider').not('.slick-initialized').slick({
		      slidesToShow:1,
		      slidesToScroll:1,
		      arrows:true,
		      dots:true,
		      prevArrow:'<div class="js-advantages-slider-prev"><svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5.89209 0.292236C6.28206 -0.0974435 6.91232 -0.0975182 7.30225 0.292236C7.69197 0.682161 7.69192 1.31243 7.30225 1.70239L3.42236 5.58228H18.5923C19.1421 5.58252 19.5922 6.03246 19.5923 6.58228C19.5923 7.13213 19.1421 7.58203 18.5923 7.58228H3.42236L7.29248 11.4719C7.68218 11.8618 7.68207 12.4921 7.29248 12.8821C6.91254 13.262 6.27234 13.2619 5.88232 12.8821L0.29248 7.29224C-0.0974805 6.90223 -0.0975065 6.27207 0.29248 5.88208L5.89209 0.292236Z" fill="#606060"/></svg></div>',
		      nextArrow:'<div class="js-advantages-slider-next"><svg width="20" height="14" viewBox="0 0 20 14" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.29 0.29248C12.68 -0.0974076 13.3202 -0.0974327 13.7002 0.29248L19.2998 5.87256C19.6898 6.26254 19.6897 6.89271 19.2998 7.28271L13.71 12.8726C13.32 13.2625 12.6898 13.2625 12.2998 12.8726C11.91 12.4826 11.9099 11.8524 12.2998 11.4624L16.1797 7.58252H1C0.45 7.58252 1.62558e-08 7.13252 0 6.58252C5.92201e-05 6.03257 0.450036 5.58252 1 5.58252H16.1699L12.29 1.70264C11.9001 1.31263 11.9001 0.682462 12.29 0.29248Z" fill="#606060"/></svg></div>',
		    }).data({ 'init-slider': 1 });
	  	} else {
			if (initLib == 1) {
				$('.js-advantages-slider.slick-initialized').slick('unslick').data({ 'init-slider': 0 });
			}
	  	}
	})
	$(window).resize();
  }
  jsFlampSlider() {
    $('.js-flamp-slider').slick({
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      slidesToShow: 1,
      fade: false,
      speed: 500,
      cssEase: 'ease-in-out',
      prevArrow: '<div class="flamp-slider-arrow--left"></div>',
      nextArrow: '<div class="flamp-slider-arrow--right"></div>'
    });
  }
  jsTeamSlider() {
    $('.js-team-slider').slick({
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      slidesToShow: 4,
      fade: false,
      speed: 500,
      cssEase: 'ease-in-out',
      prevArrow: '<div class="team-slider-arrow--left"></div>',
      nextArrow: '<div class="team-slider-arrow--right"></div>',

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    });
  }
  jsModifSlider() {
    $('.js-model-car').slick({
      slidesToScroll: 1,
      dots: false,
      arrows: true,
      slidesToShow: 3,
      fade: false,
      speed: 500,
      cssEase: 'ease-in-out',
      prevArrow: '<div class="team-slider-arrow--left"></div>',
      nextArrow: '<div class="team-slider-arrow--right"></div>',

      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 780,
          settings: {
            slidesToShow: 1,
          }
        },
        {
          breakpoint: 577,
          settings: {
            slidesToShow: 1,
          }
        },
      ]
    });
  }
}

export {
  Sliders
};
